
/*
export function SOME_ACTION({state, commit}) {

  return state;
}
*/
